<div class="col-12">
    <p-table 
      [value]="donorLetters" 
      dataKey="id"
      styleClass="datatable-sm"
      [scrollable]="true" 
      scrollHeight="400px">

      <ng-template pTemplate="header">
        <tr>
          <th>Letter Type</th>
          <th>Date Sent</th>
          <th>Response Date</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-donorLetterItem let-expanded="expanded">
        <tr>
          <td>{{ donorLetterItem.letterType }}</td>
          <td>{{ donorLetterItem.dateSent | date : 'M/d/yyyy' }}</td>
          <td>{{ donorLetterItem.responseReceivedDate | date : 'shortDate' }}</td>
          <td>
            <rc-generic-button label="Edit" iconImg="cog" iconColor="teal-light" [isIconOnly]="true" [classes]="['table-action-btn']" data-cy="btn-edit"
                                (clickHandler)="onAddEditDonorLetter(donorLetterItem)"/>
            <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-delete"
                                [classes]="['table-action-btn']" (clickHandler)="onDeleteDonorLetter(donorLetterItem)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" *ngIf="donorLetters.length==0">
        <tr>
          <td [attr.colspan]="4" style="text-align: center;">
            There are no donor letters for this donor.
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="flex justify-content-end mt-2">
      <rc-generic-button label="Add New Letter" iconImg="plus" borderStyle="text-only" level="secondary" size="small" [classes]="['mx-1']" (click)="onAddEditDonorLetter()" />     
    </div>
</div>



<!-- Add Donor Letter MODAL -->
<div id="add-donor-letter-card" data-cy="add-donor-letter-card">
  <p-dialog [(visible)]="showAddDonorLetterDialog"
    [header]="(isEditMode ? 'Edit' : 'Add') + ' Donor Letter'" 
    [modal]="true"
    styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300" >

    <form [formGroup]="donorLetterFormGroup">
      <div>
        <div class="formgrid">
          <div class="field">
            <label for="letterTypeId" class="field-label required">Letter Type</label>
            
            <p-dropdown formControlName="letterTypeId" id="letterTypeId" 
                        [options]="donorLetterTypes" optionLabel="value" optionValue="key"
                        placeholder="Please Select"
                        [disabled]="isEditMode" />
            <div *ngIf="donorLetterFormGroup.controls['letterTypeId'].invalid && donorLetterFormGroup.controls['letterTypeId'].touched" class="block p-error">
              <small id="letterType-error" class="error"> Please select letter type. </small>
            </div>
          </div>
          <div class="field">
            <label for="letterSendDate" class="field-label required">Send Date</label>
            <p-calendar formControlName="dateSent" id="dateSent" [showIcon]="true" [iconDisplay]="'input'" placeholder="MM/DD/YYYY">
            </p-calendar>
          </div>
          <div class="field">
            <label for="responseReceivedDate" class="field-label required">Response Date</label>
            <p-calendar formControlName="responseReceivedDate" id="responseReceivedDate" [showIcon]="true" [iconDisplay]="'input'" placeholder="MM/DD/YYYY">
            </p-calendar>
          </div>
          <div class="field" *ngIf="donorLetterFormGroup.value.responseReceivedDate">
            <label for="letterReturnTypeId" class="field-label required">Status</label>
            <p-dropdown formControlName="letterReturnTypeId" id="letterReturnTypeId" 
                        [options]="donorReturnLetterTypes" optionLabel="value" optionValue="key"
                        placeholder="Please Select" showClear="true" />
          </div>
          <div *ngIf="donorLetterFormGroup.value.letterReturnTypeId">
            <div class="field">              
              <label for="employer" class="field-label required">Employer</label>              
              <rc-input id="employer" pInputText formControlName="employer" placeholder="" type="text"
                [control]="donorLetterFormGroup.controls['employer']" />
            </div>
            <div class="field">              
              <label for="occupation" class="field-label required">Occupation</label>              
              <rc-input id="occupation" pInputText formControlName="occupation" placeholder="" type="text"
                [control]="donorLetterFormGroup.controls['occupation']" />
            </div>
            <div class="field">  
              <label for="isRetired" class="field-label required">Is Retired</label>             
              <p-toggleButton name="isRetired" onLabel="Yes" offLabel="No" onIcon="pi pi-check-circle"
                offIcon="pi pi-ban" formControlName="isRetired"
                (onChange)="onIsRetiredChanged($event)" />
            </div>
        </div>
        </div>
      </div>
      
    </form>
  
    <ng-template pTemplate="footer">
      <p-button 
          label="Cancel" 
          [text]="true" 
          (onClick)="closeAddEditDialog()" />
      <p-button 
          label="Save" 
          (onClick)="saveDonorLetter()" />
    </ng-template>
  </p-dialog>
</div>

<!-- Confirm Dialog -->
<rc-generic-confirmation
  [visible]="showDeleteDonorLetterDialog"
  title="Delete Letter"
  message="Are you sure you want to delete this letter?"
  confirmText="Delete"
  cancelText="Cancel"
  [dataObject]="donorLetterToDelete"
  (onConfirm)="onDeleteDonorLetterConfirm($event)"
  (onCancel)="onDeleteDonorLetterCancel()" />
